export default "__VITE_ASSET__a1b79d68__"